import { Button, Typography } from "@material-ui/core";
import { AssignAssessmentRequest } from "api/thorRequestModels/Events/AssignAssessmentRequest";
import { observer } from "mobx-react";
import React from "react";
import { useStore } from "store/StoreConfigs";
import { reviewAssessmentStyles } from "./ReviewAssessmentStyles";
import { AssessmentStatus } from "models/thorEventModels/BatchImpactAssessment";
import { pluralize } from "helpers/pluralize";
import LynxSelect from "components/LynxSelect/LynxSelect";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { ReviewAssessmentProps } from "./ReviewAssessmentProps";
import clsx from "clsx";

export default observer(function ReviewAssessment({
    batchId,
    assessmentStatusId,
    quantity,
    isReturnedToStock,
}: ReviewAssessmentProps) {
    const classes = reviewAssessmentStyles();
    const { thorEventViewStore, identityStore } = useStore();

    const handleReturnToStockDecision = (e: any) => {
        thorEventViewStore.returnToStock({
            batchId: batchId,
            decision: e.target.value === "yes",
            eventId: thorEventViewStore.eventDetails.eventId,
            customerId: identityStore.currentCustomerId,
        });
    };

    return assessmentStatusId === AssessmentStatus.PendingReview ? (
        <div className={classes.main}>
            {thorEventViewStore.IsReturnedToStockSet ? (
                <div className={classes.smallIndicator}>
                    <LoadingIndicator />
                </div>
            ) : (
                <div className={classes.selectContainer}>
                    <LynxSelect
                        label={pluralize("Is", quantity) + " " + pluralize("product", quantity) + " going to stock?"}
                        margin={"0px 0px 0px 0px"}
                        isMultiple={false}
                        value={isReturnedToStock === null ? "" : isReturnedToStock ? "yes" : "no"}
                        onChange={handleReturnToStockDecision}
                        options={[
                            {
                                itemName: "Choose the option",
                                itemValue: "",
                                isDisabled: true,
                            },
                            {
                                itemName: "Yes",
                                itemValue: "yes",
                            },
                            {
                                itemName: "No",
                                itemValue: "no",
                            },
                        ]}
                    />
                </div>
            )}

            <Button
                className={clsx(classes.btn, {
                    [classes.disabledBtn]: isReturnedToStock === null,
                })}
                disabled={isReturnedToStock === null}
                onClick={() => {
                    const request: AssignAssessmentRequest = {
                        batchId: batchId,
                        eventId: thorEventViewStore.eventDetails.eventId,
                        customerId: identityStore.currentCustomerId,
                    };

                    thorEventViewStore.setAssessmentStatus(request);
                }}
            >
                <Typography>Assessment Completed</Typography>
            </Button>
        </div>
    ) : null;
});
